/**
 * The order page lives on its own host: store.<domain> (localstore.<domain> in development). The one place of this
 * rule for the app; `index.html` keeps a copy for the referrer policy, which must run before the bundle loads.
 */
export const isStorePanelHostname = (
  hostname: string = window.location.hostname,
) => {
  const hostParts = hostname.split(".");

  if (hostParts.length < 3) {
    return false;
  }

  return ["store", "localstore"].includes(hostParts[0]);
};
